/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IPlatformAndArenaFeeCurrency,
  IPlatformAndArenaFeeCurrencyInterface,
} from "../IPlatformAndArenaFeeCurrency";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFeeCurrency",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IPlatformAndArenaFeeCurrency__factory {
  static readonly abi = _abi;
  static createInterface(): IPlatformAndArenaFeeCurrencyInterface {
    return new utils.Interface(_abi) as IPlatformAndArenaFeeCurrencyInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IPlatformAndArenaFeeCurrency {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IPlatformAndArenaFeeCurrency;
  }
}
